export default {
      id: "ic-misc-fav-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-fav-usage",
      toString: function () {
        return this.url;
      }
    }